const fileId = d => d.file_id || d.id;
const category = d => d.legal_category || 'Needs review';
const natural = (a,b) => (a || '').localeCompare(b || '',undefined,{numeric:true,sensitivity:'base'});

export function buildDocumentGroups(documents){
  const groups=new Map();
  for(const doc of documents){
    const key=doc.document_group_id || fileId(doc);
    if(!groups.has(key))groups.set(key,[]);
    groups.get(key).push(doc);
  }
  return [...groups.entries()].map(([key,all])=>{
    const ids=new Set(all.map(fileId));
    const pages=all.filter(d=>!ids.has(d.duplicate_of_file_id || d.duplicate_of));
    const ordered=(pages.length?pages:all).sort((a,b)=>(a.page_number||1)-(b.page_number||1)||natural(a.original_filename,b.original_filename));
    return {...ordered[0],group_key:key,grouped_pages:ordered,stored_file_count:all.length,
      duplicate_copy_count:all.length-ordered.length,search_pages:all};
  }).sort((a,b)=>natural(a.business_entity_name,b.business_entity_name)||natural(a.original_filename,b.original_filename));
}

export function filterDocumentGroups(groups,{folder='All documents',business='all',search=''}={}){
  const query=search.toLowerCase();
  return groups.filter(g=>(business==='all'||(g.business_entity_id||'unassigned')===business)
    &&(folder==='All documents'||g.search_pages.some(d=>category(d)===folder))
    &&g.search_pages.some(d=>[d.document_title,d.original_filename,d.document_type_label,d.legal_matter,
       d.business_entity_name,d.record_path,d.note].join(' ').toLowerCase().includes(query)));
}
